<section class="branch-register">
	<div class="container">
		<div class="row">
			<div class="col-12 form-container">
				<form [formGroup]="form" (ngSubmit)="onSubmitEventHandler(form.value)" autocomplete="off">
					<div>
						<span style="color: #FF6600; font-weight: bold; font-size: 24px">
              {{ isEdit ? 'Editar caja' : 'Agregar caja' }}
            </span>
					</div>
					<div class="row mt-4">
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<mat-form-field class="input-yaca w-100">
								<mat-label>Nombre</mat-label>
								<input
									matInput
									type="text"
									formControlName="name"
									[placeholder]="translate('pages.cashiers.labels.name_placeholder')"
									maxlength="100"
								/>
								<mat-error *ngIf="true">{{ 'commons.errors.required' | translate: messageValidatorParam }}</mat-error>
							</mat-form-field>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<mat-form-field class="input-yaca w-100">
								<mat-label>{{ 'pages.cashiers.labels.branch_office_select' | translate }}</mat-label>
								<mat-select #branchSelect formControlName="branchOffice" [compareWith]="compareBranchOffices" [disabled]="isEdit">
									<mat-option *ngFor="let branch of branchOfficesCollection" [value]="branch"> {{ branch.display }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 v-center">
							<mat-slide-toggle color="primary" formControlName="paymentOrders">
								{{ 'pages.cashiers.labels.payment_orders' | translate }}
							</mat-slide-toggle>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<mat-form-field class="input-yaca w-100">
								<mat-label>Id en QR otros (opcional)</mat-label>
								<input
									matInput
									type="text"
									formControlName="externalQrId"
									[placeholder]="translate('pages.cashiers.labels.qr_external_placeholder')"
									maxlength="100"
									[readonly]="!form.get('paymentOrders').value"
								/>
							</mat-form-field>
						</div>
					</div>
					<div class="form-group row text-right">
						<div class="col-12">
							<button mat-stroked-button class="w-button mr-3 button-back" type="button" (click)="goBack()">
								{{ 'commons.buttons.back' | translate }}
							</button>
							<button
								*ngIf="isEdit"
								mat-raised-button
								button="submit"
								tabindex="0"
								color="primary"
								style="margin-right: 1rem"
								[ngClass]="{ 'button-save': editado || saving }"
								[disabled]="!editado || saving"
							>
								{{ 'commons.buttons.save' | translate }}
							</button>
							<button
								*ngIf="!isEdit"
								mat-raised-button
								button="submit"
								tabindex="0"
								color="primary"
								style="margin-right: 1rem"
								[ngClass]="{ 'button-save': !form.invalid }"
								[disabled]="form.invalid"
							>
								{{ 'commons.buttons.save' | translate }}
							</button>
						</div>
					</div>
					<div class="row" *ngIf="saving">
						<div class="col-12">
							<div class="action-label">
								<span class="action-text">{{ 'pages.responsibles.labels.saving' | translate }}</span>
								<mat-spinner mode="indeterminate" diameter="25"></mat-spinner>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</section>
